export type Team = {
  id: number;
  subdomain: string;
  applications: number[];
  users: number[];
  liveChatOn: boolean;
  teamName: string;
  teamSize: number;
  usedSeatCount: number;
  expirationDate: Date;
  expired: boolean;
  adminEmails: string[];
  demoTeam: boolean;
  hasCustomEusa: boolean;
  oktaClientId: string;
  oktaClientSecret: string;
  emailNotifications: boolean;
  userAndGroupManagementMode: TeamUserAndGroupManagementMode;
};

export type TeamsGetResponse = Team[];

export type TeamGetResponse = Team;

export type TeamAddRequest = {
  teamName: string;
  adminEmails: string[];
  expirationDate: Date;
  teamSize: string;
  subdomain: string;
  liveChatOn?: boolean;
  demoTeam?: boolean;
  federatedAuth?: boolean;
  userAndGroupManagementMode: TeamUserAndGroupManagementMode;
};

export type TeamEditRequest = Team;

export type TeamEditResponse = Team;

export type TeamSyncResponse = {
  applicationId: string;
  clientId: string;
  clientSecret: string;
  groupIds: Record<string, string>;
};

export enum TeamUserAndGroupManagementMode {
  internal = "INTERNAL",
  externalWithScimApi = "EXTERNAL_WITH_SCIM_API",
  externalWithGroupsClaim = "EXTERNAL_WITH_GROUPS_CLAIM"
}

export const isExternalGroupManagement = (
  userAndGroupManagementMode?: TeamUserAndGroupManagementMode,
): boolean => {
  return (
    userAndGroupManagementMode === TeamUserAndGroupManagementMode.externalWithScimApi ||
    userAndGroupManagementMode === TeamUserAndGroupManagementMode.externalWithGroupsClaim
  );
};
